package org.dronda.app.web.ui.util

import org.dronda.app.web.ui.components.ExclusionLabel
import org.dronda.app.web.ui.components.SelectOption
import org.dronda.service.wishlist.core.domain.SantaExclusionDirection

internal val exclusionDirectionChoices = listOf(
    SelectOption(value = SantaExclusionDirection.BOTH.name, label = "won't draw each other"),
    SelectOption(value = SantaExclusionDirection.A_TO_B.name, label = "won't draw"),
)

internal fun exclusionLabel(a: String, b: String, direction: SantaExclusionDirection): ExclusionLabel {
    fun name(text: String) = ExclusionLabel.Part(text, isName = true)
    fun words(text: String) = ExclusionLabel.Part(text, isName = false)

    return ExclusionLabel(
        when (direction) {
            SantaExclusionDirection.BOTH -> listOf(name(a), words("and"), name(b), words("won't draw each other"))
            SantaExclusionDirection.A_TO_B -> listOf(name(a), words("won't draw"), name(b))
            SantaExclusionDirection.B_TO_A -> listOf(name(b), words("won't draw"), name(a))
        }
    )
}
